import { FeedbackState, TypeArray, AnswerType } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"
import {
  processActionMeta,
  getArrayTypeReducerGuard
} from "../reducers"
import { FeedbackStateSchema } from "../schemas"

import _ from "lodash"

export type AnswerState = {
  selected: boolean
  disabled: boolean
  correct: boolean
  value: string
  type: AnswerType | null
  aidx: number | null // this is the index of the answer that was dropped here
  id?: string
}

const reducerAction = {
  id: actionCreatorTypeGuard<AnswerState, string | null>("id", "AnswerState"),
  aidx: actionCreatorTypeGuard<AnswerState, number | null>(
    "aidx",
    "AnswerState"
  ),
  correct: actionCreatorTypeGuard<AnswerState, boolean>(
    "correct",
    "AnswerState"
  ),
  selected: actionCreatorTypeGuard<AnswerState, boolean>(
    "selected",
    "AnswerState"
  ),
  disabled: actionCreatorTypeGuard<AnswerState, boolean>(
    "disabled",
    "AnswerState"
  ),
  value: actionCreatorTypeGuard<AnswerState, string>("value", "AnswerState"),
  type: actionCreatorTypeGuard<AnswerState, AnswerType | null>(
    "type",
    "AnswerState"
  ),
  __record: actionCreatorTypeGuard<TypeArray, AnswerState>(
    "AnswerState",
    "__record"
  ),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<AnswerState>>(
    "create",
    "__create/AnswerState"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record"),
  __null: actionCreatorTypeGuard<TypeArray, null>("null", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof AnswerState
    | "__record"
    | "__delete"
    | "__create"
    | "__null"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const answerStateAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

const validationOptions = {
  strict: true,
  abortEarly: false,
  stripUnknown: true,
  recursive: true
}

export const answerStateReducer = reducerTypeGuard<AnswerState>()
  .case(...reducerAction.correct)
  .case(...reducerAction.selected)
  .case(...reducerAction.disabled)
  .case(...reducerAction.value)
  .case(...reducerAction.aidx)
  .case(...reducerAction.id)
  .case(...reducerAction.type)
  .build()
